import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SurveyResults from "./index";
import {
  changeStep,
  fetchResult,
  fetchDrivers
} from "../../modules/results/actions";
import { changeLanguage } from "../../modules/preference/actions";

class SurveyResultsContainer extends React.Component {
  componentWillMount() {
    
    const { search } = this.props.location;
    const { id } = this.props.match.params;

    if (search && search === "?step=REPORT") {
      this.props.changeStep("REPORT");
    }

    this.props.fetchResult(id);

    this.props.fetchDrivers(id);
  }

  componentDidUpdate() {
    if(this.props.transactionalanalysisId) {
      this.props.fetchDrivers(this.props.transactionalanalysisId)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.language !== nextProps.language) {
      const { id } = this.props.match.params;

      this.props.fetchResult(id);
    }
  }
  render() {
    return <SurveyResults {...this.props} />;
  }
}

function mapStateToProps(state) {
  return {
    transactionalanalysisId: state.results.transactionalAnalysisId,
    step: state.results.step,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  changeStep,
  fetchResult,
  fetchDrivers,
  changeLanguage
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(SurveyResultsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/SurveyResultsContainer.js